$(document).on('turbolinks:load', () => {
  if (window.location.pathname.includes('/read')) {
    $('nav#top_navbar a.nav-link:contains("Read")').addClass('active')
  }
})
